import React from "react";
import { STATUS } from "@/mock/data";
import { MatterCard, CompactMatterRow } from "@/components/MatterCard";
import { HistoricoAsuntos, esHistorico } from "@/components/asuntos/HistoricoAsuntos";

const GroupHeader = ({ color, label, count }) => (
  <div className="flex items-center gap-3 mb-3 mt-2">
    <span className="w-3 h-3 rounded-full" style={{ backgroundColor: color }} />
    <h2 className="font-heading text-lg sm:text-xl font-bold text-[#1C2421] tracking-tight">
      {label}
    </h2>
    <span className="text-sm font-bold text-[#6E7A74] bg-[#F2EDE4] rounded-full px-2.5 py-0.5">
      {count}
    </span>
  </div>
);

// Renderiza los asuntos en los tres grupos de estado con la misma lógica visual
// que Inicio (tarjetas grandes para atención/próximos, compactas para bajo control).
export const MatterGroups = ({ matters, emptyText = "No hay asuntos en esta vista.", hideControlled = false, historico = false }) => {
  const attention = matters.filter((m) => m.status === STATUS.ATTENTION);
  const upcoming = matters.filter((m) => m.status === STATUS.UPCOMING);
  const controlled = matters.filter((m) => m.status === STATUS.CONTROLLED);

  const pasados = historico ? matters.filter(esHistorico) : [];
  const visibleCount = attention.length + upcoming.length + (hideControlled ? 0 : controlled.length);
  if (visibleCount === 0) {
    return (
      <div className="space-y-4">
        {(emptyText || !pasados.length) && <p className="text-base text-[#6E7A74] bg-white border border-[#E5DFD5] rounded-2xl p-6 text-center">{emptyText}</p>}
        {pasados.length > 0 && <HistoricoAsuntos matters={pasados} />}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {attention.length > 0 && (
        <section data-testid="group-attention">
          <GroupHeader color="#DC2626" label="Requiere atención" count={attention.length} />
          <div className="space-y-4">
            {attention.map((m, i) => (
              <MatterCard key={m.id} matter={m} index={i} />
            ))}
          </div>
        </section>
      )}

      {upcoming.length > 0 && (
        <section data-testid="group-upcoming">
          <GroupHeader color="#D97706" label="Próximamente" count={upcoming.length} />
          <div className="space-y-4">
            {upcoming.map((m, i) => (
              <MatterCard key={m.id} matter={m} index={i} />
            ))}
          </div>
        </section>
      )}

      {!hideControlled && controlled.length > 0 && (
        <section data-testid="group-controlled">
          <GroupHeader color="#16A34A" label="Documentación al día" count={controlled.length} />
          <div className="space-y-2.5">
            {controlled.map((m, i) => (
              <CompactMatterRow key={m.id} matter={m} index={i} />
            ))}
          </div>
        </section>
      )}
      {pasados.length > 0 && <HistoricoAsuntos matters={pasados} />}
    </div>
  );
};
